import api from './api';

const billService = {
    checkout: async (payload = {}) => {
        const response = await api.post('/bills/checkout', payload);
        return response.data;
    },

    getMyBills: async () => {
        const response = await api.get('/bills/my-bills');
        return response.data;
    },

    getBillDetails: async (billNo) => {
        const response = await api.get(`/bills/${billNo}`);
        return response.data;
    }
};

export default billService;
